import { Observable } from 'rxjs'

/**
 * Wraps a field's `focus$` so the field's text is also selected and typing
 * replaces it. The field must focus synchronously when the result emits.
 * Nothing is selected when focus didn't move, e.g. because the field is
 * disabled, so another field's text is never selected.
 *
 * @param focus$ Observable that emits when the field should be focused.
 */
export function selectOnFocusRequest<T>(focus$: Observable<T>): Observable<T> {
  return new Observable<T>((subscriber) =>
    focus$.subscribe({
      next: (value) => {
        const previous = document.activeElement
        subscriber.next(value)
        const focused = document.activeElement
        if (
          focused !== previous &&
          (focused instanceof HTMLInputElement ||
            focused instanceof HTMLTextAreaElement)
        ) {
          focused.select()
        }
      },
      error: (err: unknown) => subscriber.error(err),
      complete: () => subscriber.complete(),
    }),
  )
}
